<template>
    <a class="dashboard-stat dashboard-stat-v2" :class="[color]" href="#">
        <div class="visual">
            <i class="fa" :class="[icon]" aria-hidden="true"></i>
        </div>
        <div class="details">
            <div class="number">
                {{ prefix }}<i-count-up
                        :start="0"
                        :end="value"
                        :decimals="+hasDecimals"
                        :duration="2.5">{{ value }}
                </i-count-up>{{ postfix }}
            </div>
            <div class="desc" v-html="desc"></div>
        </div>
    </a>
</template>
<script>
  /* ============
   * Stats Component
   * ============
   *
   */
  import ICountUp from 'vue-countup-v2'

  export default {
    components: {
      ICountUp
    },
    props: {
      icon: {
        type: String,
        required: true
      },
      value: {
        type: Number,
        required: true
      },
      desc: {
        type: String,
        required: true
      },
      color: {
        type: String,
        default: 'blue'
      },
      prefix: {
        type: String
      },
      postfix: {
        type: String
      }
    },
    computed: {
      hasDecimals () {
        return Number(this.value) === this.value && this.value % 1 !== 0
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/app/components/Stats.vue